import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';

// RxJS
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

// sweetalert2
import swal from 'sweetalert2';

// Modelos
import { User } from '../../models/user.model';
import { AlarmasService } from 'src/app/services/eventos/alarmas.service';

// import { resolve } from 'path';
// import { reject } from 'q';
import { FirebasedatabaseService } from '../firebase/firebasedatabase.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user: User;
  token: string;
  menu: any[] = [];

  private authUrl = environment.apiBaseUrl + '/login';

  constructor(
    public http: HttpClient,
    public router: Router,
    public alarmasService: AlarmasService,
    private firebasedatabaseService: FirebasedatabaseService
  ) {
    this.cargarStorage();
  }

  logueado() {
    return (this.user) ? true : false;
  }

  cargarStorage() {

    if (localStorage.getItem('tokenALERT')) {
      this.token = localStorage.getItem('tokenALERT');
      this.user = JSON.parse(localStorage.getItem('usuarioALERT'));
      this.menu = JSON.parse(localStorage.getItem('menuALERT'));
    } else {
      this.token = '';
      this.user = null;
      this.menu = [];
    }
  }

  guardarStorage(token: string, user: User, menu: any) {

    user.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    localStorage.setItem('tokenALERT', token);
    localStorage.setItem('usuarioALERT', JSON.stringify(user));
    localStorage.setItem('menuALERT', JSON.stringify(menu));

    this.user = user;
    this.token = token;
    this.menu = menu;
  }

  login(authCredentials, recuerdame: boolean) {

    if (recuerdame) {
      localStorage.setItem('usuarionameALERT', authCredentials.username);
    } else {
      localStorage.removeItem('usuarionameALERT');
    }

    return this.http.post(this.authUrl, { username: authCredentials.username, password: authCredentials.password })
      .pipe(
        map((resp: any) => {
          this.firebasedatabaseService.connectFirebase();
          this.guardarStorage(resp.idtoken, resp.usuario, resp.menu);
        }),
        catchError((err: HttpErrorResponse) => {
          // console.log(err.error);
          swal('Error en el login', err.error.message, 'error');
          return Observable.throw(err);
        })
      );
  }

  logout() {

    this.router.navigate(['/auth/login']);

    // monitoreo
    if (this.user.monitoreo) {
      this.firebasedatabaseService.unSubscritionNodosMonitoreo('');
    }

    this.user = null;
    this.token = '';
    this.menu = [];

    localStorage.removeItem('tokenALERT');
    localStorage.removeItem('usuarioALERT');
    localStorage.removeItem('menuALERT');

    // location.reload();

  }

  getToken() {
    return localStorage.getItem('tokenALERT');
  }

}
